import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ['chartData', 'height', 'width'],
  data () {
    return {
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        },
        responsive: true
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}



// WEBPACK FOOTER //
// ./src/components/ReportActivity/ChartLineAllActivityMemberjoinBase.js